"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAxiosClient = exports.isAxiosError = void 0;
const axios_1 = __importDefault(require("axios"));
const CORRELATION_ID = 'X-Correlation-Id';
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function isAxiosError(error) {
    return (error === null || error === void 0 ? void 0 : error.isAxiosError) === true;
}
exports.isAxiosError = isAxiosError;
function createAxiosClient(apiHost, options = {}) {
    var _a, _b;
    const client = axios_1.default.create({
        baseURL: `${apiHost}`,
        timeout: (_a = options.timeout) !== null && _a !== void 0 ? _a : 0,
        headers: {
            Accept: (_b = options.accept) !== null && _b !== void 0 ? _b : 'application/json',
        },
    });
    function accessTokenInterceptor(config) {
        return __awaiter(this, void 0, void 0, function* () {
            if (options.accessTokenSource === undefined) {
                return config;
            }
            const accessToken = yield options.accessTokenSource();
            if (accessToken !== null) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                config.headers.Authorization = `Bearer ${accessToken}`;
            }
        });
    }
    function correlationIdInterceptor(config) {
        return __awaiter(this, void 0, void 0, function* () {
            if (options.correlationIdSource === undefined) {
                return config;
            }
            const correlationId = yield options.correlationIdSource();
            if (correlationId !== null) {
                // eslint-disable-next-line security/detect-object-injection, @typescript-eslint/no-non-null-assertion
                config.headers[CORRELATION_ID] = correlationId;
            }
        });
    }
    client.interceptors.request.use((config) => __awaiter(this, void 0, void 0, function* () {
        yield accessTokenInterceptor(config);
        yield correlationIdInterceptor(config);
        return config;
    }));
    return client;
}
exports.createAxiosClient = createAxiosClient;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXhpb3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvYXhpb3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsa0RBQTRFO0FBRTVFLE1BQU0sY0FBYyxHQUFHLGtCQUFrQixDQUFBO0FBRXpDLGlIQUFpSDtBQUNqSCxTQUFnQixZQUFZLENBQUMsS0FBVTtJQUNyQyxPQUFPLENBQUEsS0FBSyxhQUFMLEtBQUssdUJBQUwsS0FBSyxDQUFFLFlBQVksTUFBSyxJQUFJLENBQUE7QUFDckMsQ0FBQztBQUZELG9DQUVDO0FBYUQsU0FBZ0IsaUJBQWlCLENBQUMsT0FBZSxFQUFFLFVBQThCLEVBQUU7O0lBQ2pGLE1BQU0sTUFBTSxHQUFHLGVBQUssQ0FBQyxNQUFNLENBQUM7UUFDMUIsT0FBTyxFQUFFLEdBQUcsT0FBTyxFQUFFO1FBQ3JCLE9BQU8sRUFBRSxNQUFBLE9BQU8sQ0FBQyxPQUFPLG1DQUFJLENBQUM7UUFDN0IsT0FBTyxFQUFFO1lBQ1AsTUFBTSxFQUFFLE1BQUEsT0FBTyxDQUFDLE1BQU0sbUNBQUksa0JBQWtCO1NBQzdDO0tBQ0YsQ0FBQyxDQUFBO0lBRUYsU0FBZSxzQkFBc0IsQ0FBQyxNQUFtQzs7WUFDdkUsSUFBSSxPQUFPLENBQUMsaUJBQWlCLEtBQUssU0FBUyxFQUFFO2dCQUMzQyxPQUFPLE1BQU0sQ0FBQTthQUNkO1lBQ0QsTUFBTSxXQUFXLEdBQUcsTUFBTSxPQUFPLENBQUMsaUJBQWlCLEVBQUUsQ0FBQTtZQUNyRCxJQUFJLFdBQVcsS0FBSyxJQUFJLEVBQUU7Z0JBQ3hCLG9FQUFvRTtnQkFDcEUsTUFBTSxDQUFDLE9BQVEsQ0FBQyxhQUFhLEdBQUcsVUFBVSxXQUFXLEVBQUUsQ0FBQTthQUN4RDtRQUNILENBQUM7S0FBQTtJQUVELFNBQWUsd0JBQXdCLENBQUMsTUFBbUM7O1lBQ3pFLElBQUksT0FBTyxDQUFDLG1CQUFtQixLQUFLLFNBQVMsRUFBRTtnQkFDN0MsT0FBTyxNQUFNLENBQUE7YUFDZDtZQUNELE1BQU0sYUFBYSxHQUFHLE1BQU0sT0FBTyxDQUFDLG1CQUFtQixFQUFFLENBQUE7WUFDekQsSUFBSSxhQUFhLEtBQUssSUFBSSxFQUFFO2dCQUMxQixzR0FBc0c7Z0JBQ3RHLE1BQU0sQ0FBQyxPQUFRLENBQUMsY0FBYyxDQUFDLEdBQUcsYUFBYSxDQUFBO2FBQ2hEO1FBQ0gsQ0FBQztLQUFBO0lBRUQsTUFBTSxDQUFDLFlBQVksQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQU8sTUFBTSxFQUFFLEVBQUU7UUFDL0MsTUFBTSxzQkFBc0IsQ0FBQyxNQUFNLENBQUMsQ0FBQTtRQUNwQyxNQUFNLHdCQUF3QixDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBQ3RDLE9BQU8sTUFBTSxDQUFBO0lBQ2YsQ0FBQyxDQUFBLENBQUMsQ0FBQTtJQUVGLE9BQU8sTUFBTSxDQUFBO0FBQ2YsQ0FBQztBQXRDRCw4Q0FzQ0MifQ==